import api from "@/assets/js/api"; // 引用 API 模組
import Cookies from "js-cookie";
import Auth from "@/assets/js/auth"; // 引用 Auth 模組
import Swal from "sweetalert2"; // 引入 SweetAlert2 用於提示

export default {
  data() {
    return {
      num1: Math.floor(Math.random() * 10), // 初始化為隨機數 0-9
      num2: Math.floor(Math.random() * 10), // 初始化為隨機數 0-9
      userInput: "", // 使用者輸入的驗證碼
      formData: {
        email: "",
        password: "",
      },
    };
  },

  created() {
    this.generateCaptcha(); // 初始化時生成驗證碼
  },

  methods: {
    // 產生隨機驗證碼
    generateCaptcha() {
      this.num1 = Math.floor(Math.random() * 10); // 生成 0-9 的隨機數
      this.num2 = Math.floor(Math.random() * 10); // 生成 0-9 的隨機數
      this.userInput = ""; // 清空輸入框
    },

    // 驗證使用者輸入的答案
    validateCaptcha() {
      const correctAnswer = this.num1 + this.num2; // 計算正確答案
      if (parseInt(this.userInput) === correctAnswer) {
        return true; // 驗證成功
      } else {
        Swal.fire({
          icon: "error", // 設定錯誤圖示
          title: "驗證碼錯誤", // 標題文字
          text: "請重新輸入！", // 內文文字
        }); // 顯示 SweetAlert2 錯誤提示視窗

        this.generateCaptcha(); // 錯誤時重新生成驗證碼
        return false;
      }
    },

    // 驗證 Google Credential
    validateGoogleCredential(response) {
      const credential = response?.credential;
      if (!credential) {
        Swal.fire({
          icon: "error", // 設定錯誤圖示
          title: "Google 登入憑證缺失！", // 標題文字
          text: "請重新登入！", // 內文文字
        }); // 顯示 SweetAlert2 錯誤提示視窗

        return null;
      }
      return credential;
    },

    // 解碼 Google JWT
    decodeGoogleJWT(credential) {
      try {
        const profile = JSON.parse(
          decodeURIComponent(
            escape(
              window.atob(
                credential.split(".")[1].replace(/-/g, "+").replace(/_/g, "/")
              )
            )
          )
        );
        return {
          email: profile.email,
          fullName: profile.name,
        };
      } catch (error) {
        console.error("JWT 解碼錯誤:", error);
        Swal.fire({
          icon: "error", // 錯誤圖示
          title: "解碼失敗", // 標題
          text: "Google 用戶資訊解碼失敗！", // 提示文字
        }); // 顯示 SweetAlert2 錯誤提示

        return null;
      }
    },

    // 傳送 Google 用戶資訊到後端
    async sendGoogleUserToBackend(Email, FullName) {
      try {
        const apiResponse = await api.post("/Login/google-register", {
          Email,
          FullName,
        });
        return apiResponse;
      } catch (error) {
        console.error("Google 註冊錯誤:", error);
        const message =
          error.response?.data?.message || "伺服器錯誤，請稍後再試！";
        throw new Error(message);
      }
    },

    // 提交登入資料
    async handleLogin() {
      if (!this.validateCaptcha()) {
        return;
      }

      try {
        // 檢查 formData 是否包含 email 和 password
        if (!this.formData.email || !this.formData.password) {
          Swal.fire({
            icon: "warning", // 警告圖示
            title: "欄位未填寫", // 標題
            text: "請確保 Email 和密碼已輸入！", // 提示文字
          }); // 顯示 SweetAlert2 警告提示

          return;
        }

        const response = await api.post("/Login/login", {
          Email: this.formData.email,
          Password: this.formData.password,
        });

        if (response.data.success) {
          Swal.fire({
            icon: "success", // 成功圖示
            title: "登入成功！", // 成功提示標題
            showConfirmButton: false, // 不顯示確認按鈕
            timer: 1500, // 1.5 秒後自動關閉
          }); // 顯示 SweetAlert2 成功提示

          const { token } = response.data; // 解構後端返回的角色和 Token

          // 儲存資料到 Cookies
          Cookies.set("token", token, { expires: 7 }); // 設定 cookies 過期時間為 7 天

          // 基於角色跳轉
          Auth.redirectToRolePage(this.$router);
        } else {
          Swal.fire({
            icon: "error", // 錯誤圖示
            title: "登入失敗", // 標題
            text: response.data.message || "登入失敗！", // 顯示後端回傳訊息，若無則顯示預設文字
          }); // 顯示 SweetAlert2 錯誤提示

          this.generateCaptcha();
        }
      } catch (error) {
        console.error("登入錯誤", error.response?.data || error.message);
        Swal.fire({
          icon: "error", // 錯誤圖示
          title: "錯誤發生", // 標題
          text: error.response?.data?.message || "伺服器錯誤，請稍後再試！", // 顯示後端錯誤訊息，無則顯示預設文字
        }); // 顯示 SweetAlert2 錯誤提示
        this.generateCaptcha();
      }
    },

    /// 處理 Google 登入
    async handleGoogleLogin(response) {
      try {
        const credential = this.validateGoogleCredential(response);
        if (!credential) return;

        const userInfo = this.decodeGoogleJWT(credential);
        if (!userInfo || !userInfo.email || !userInfo.fullName) {
          Swal.fire({
            icon: "error", // 錯誤圖示
            title: "資料取得失敗", // 標題
            text: "無法獲取完整的 Google 用戶資訊！", // 提示內容
          }); // 顯示 SweetAlert2 錯誤提示視窗

          return;
        }

        const apiResponse = await this.sendGoogleUserToBackend(
          userInfo.email,
          userInfo.fullName
        );

        if (apiResponse.data.success) {
          const token = apiResponse.data.token; // 後端應該返回 token

          // 儲存資料到 Cookies
          Cookies.set("token", token, { expires: 7, secure: true }); // 設定 cookies 過期時間為 7 天

          // 基於角色跳轉
          Auth.redirectToRolePage(this.$router);
        } else {
          Swal.fire({
            icon: "error", // 錯誤圖示
            title: "Google 登錄失敗", // 標題
            text: apiResponse.data.message || "Google 登錄失敗！", // 顯示後端回傳訊息，若無則顯示預設訊息
          }); // 顯示 SweetAlert2 錯誤提示
        }
      } catch (error) {
        Swal.fire({
          icon: "error", // 錯誤圖示
          title: "發生錯誤", // 標題
          text: error.message, // 顯示錯誤訊息
        }); // 顯示 SweetAlert2 錯誤提示
      }
    },

    // LINE 登入 - 簡化版，只負責跳轉到授權頁面
    async handleLineLogin() {
      try {
        console.log("開始 LINE 登入流程...");

        // 直接呼叫後端的 LINE 登入 API
        const response = await api.get("/Line/login");

        console.log("後端回應:", response.data);

        if (response.data.success && response.data.authUrl) {
          console.log("跳轉到 LINE 授權頁面:", response.data.authUrl);
          // 後端返回授權 URL，直接跳轉到 LINE 授權頁面
          // LINE 會自動跳轉到 /line-callback 頁面處理後續邏輯
          window.location.href = response.data.authUrl;
        } else {
          throw new Error(response.data.message || "無法取得 LINE 授權連結");
        }
      } catch (error) {
        console.error("LINE 登入錯誤:", error);
        Swal.fire({
          icon: "error",
          title: "LINE 登入失敗",
          text:
            error.response?.data?.message || "無法進行 LINE 登入，請稍後再試！",
        });
      }
    },
  },
};
